import Vue from "vue";
import Vuex, { mapMutations } from "vuex";
import app from './modules/app'
import getters from './getters'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    enterpriseId: "", //企业id
    appId: "",
    appName: "",
    ip: "",
    popupType: "", //弹框类型
    seatList: [], //坐席渠道列表
    ZRG: false, //是否触发转人工
    chatBridge: false, //是否接入人工
    chatLocation: false, //是否在人工排队状态
    accessId: "", //转人工需要传的id
    mainUniqueId: "", //主会话id
    investigation: {}, //满意度参数
    leaveMsgData: {}, //留言参数
    closeTips: "", //关闭会话的提示
    seatAvatar: require("@/assets/img/seatAvatar.png"), //人工头像
    tenantId: "", //租户
    platform: "", //平台
    isOut: "", //是否对外
    allData: {
      //页面所有信息
    },
    thinking: false,
    msgList: [
      {
        senderType: 5, //机器人欢迎语热点问题推送
      },
    ], //消息列表
    emojiShow: false, //控制表情包显隐
    userId: "", //用户id 问问题传
    isMac: false, //判断电脑是否mac系统
    sessionId: "", //会话id
    isIframe: false,
    showPageId: "", //会话记录id
    chatId: "",
    wsChat: false, //是否在回答中
    msgModelList: [
      {
        senderType: 5, //机器人欢迎语热点问题推送
      },
      {
        qaId: "01JDPDRBZ43YTMG04HRXPQF8SZ",
        chatId: "01JDPDRBZ51R8ZKGTTXPEWPK77",
        userCode: "10231376",
        question: "红红火火恍恍惚惚或投诉",
        answer:
          '1. 非常抱歉，我需要先澄清一下，您的问题似乎是一句不完整或者带有俚语和网络用语的句子，"红红火火恍恍惚惚或投诉"。在我的资料库中，我没有找到直接对应这个短语的特定解释或答案。我是一个以精确和专业为原则的AI助手，对于一些特定的俚语、网络用语或者没有明确问题的句子，我可能需要更清晰的指引才能提供准确的帮助。如果这是一个特定问题的组成部分，或者您需要关于某个具体主题的信息，欢迎提供更多信息，我将尽我最大的能力来帮助您。如果需要更直接的人工服务，我建议您前往IT服务窗口进行咨询，他们能提供更个性化的帮助。\n\n2. 当然，如果这句话是您在某种情绪下的表达，比如"红红火火"可能意味着生活或工作非常忙碌且充满活力，"恍恍惚惚"可能表示您感到有些迷茫或者注意力不集中，而"或投诉"可能是您在考虑是否对某个问题进行反馈或投诉。请理解，这只是我的一种猜测，如果这是您想表达的意思，那么我希望我的理解能帮到您。如果我的理解有误，或者您有其他问题，随时告诉我，我将很乐意以最礼貌和专业的态度为您提供帮助。',
        id: "",
        sessionName: "",
        evaluateType: "",
        qTime: "2024-11-27 17:03:16",
        aTime: "2024-11-27 17:03:16",
      },
    ],
  },
  mutations: {
    handleAppId(state, payload) {
      //ws
      state.appId = payload;
    },
    handleAppName(state, payload) {
      //ws
      state.appName = payload;
    },
    handleIp(state, payload) {
      //ws
      state.ip = payload;
    },
    handleCloseTips(state, payload) {
      //ws-会话结束提示
      state.closeTips = payload;
    },
    queryHistory(state, payload) {
      //历史记录
      state.msgList.unshift(payload);
    },
    enterpriseId(state, payload) {
      //ws-企业id
      state.enterpriseId = payload;
    },
    handlePopupType(state, payload) {
      //处理弹框类型
      state.popupType = payload;
    },
    handleSeatList(state, payload) {
      //获取坐席渠道列表
      state.seatList = payload;
    },
    handleZRG(state, payload) {
      //处理触发转人工状态
      state.ZRG = payload;
    },
    handleMainUniqueId(state, payload) {
      //处理主会话id
      state.mainUniqueId = payload;
    },
    handleLeaveMsgData(state, payload) {
      //获取留言
      state.leaveMsgData = payload;
    },
    getInvestigation(state, payload) {
      //获取满意度调查参数
      state.investigation = payload;
    },
    seatAvatar(state, payload) {
      //处理坐席头像
      state.seatAvatar = payload;
    },
    handlechatBridge(state, payload) {
      //人工连接是否建立
      state.chatBridge = payload;
    },
    handleChatLocation(state, payload) {
      //人工排队状态
      state.chatLocation = payload;
    },
    handleAccessId(state, payload) {
      //获取转人工accessId
      state.accessId = payload;
    },
    handleIsOut(state, payload) {
      //处理是否对外
      state.isOut = payload;
    },
    handleTenantId(state, payload) {
      //处理租户id
      state.tenantId = payload;
      sessionStorage.setItem("tenantId", payload);
    },
    handlePlatform(state, payload) {
      //处理平台
      state.platform = payload;
    },
    handleSessionId(state, payload) {
      //处理会话id
      state.sessionId = payload;
    },
    handleIsMac(state, payload) {
      //处理电脑系统
      state.isMac = payload;
    },
    handleIsIframe(state, payload) {
      //处理右下角iframe
      state.isIframe = payload;
    },
    handleEmoji(state, payload) {
      //处理表情显示隐藏
      state.emojiShow = payload;
      console.log("改變", state.emojiShow);
    },
    getAllData(state, paylod) {
      //获取所有数据
      state.allData = paylod;
    },
    insertMessage(state, payload) {
      //插入消息
      state.msgList.push(payload);
    },
    withdrawMessage(state, payload) {
      //撤回消息
      let index = state.msgList.findIndex(
        (item) => item.messageUniqueId == payload.messageUniqueId
      );
      state.msgList.splice(index, 1, payload);
    },
    handleMsgSolve(state, index) {
      //处理解决未解决禁用属性
      state.msgList.splice(index, 1, {
        ...state.msgList[index],
        disabled: true,
      });
    },
    handleLeaveMsg(state, id) {
      //留言提交后禁用
      state.msgList.forEach((item) => {
        if (item.uuid == id) {
          item.isLeave = true;
        }
      });
    },
    msglistMessage(state, payload) {
      state.msgList = [{ senderType: 5 }, ...payload];
    },
    getUserId(state, payload) {
      state.userId = payload;
    },
    createMessage(state, payload) {
      //新建消息
      state.msgModelList = [
        {
          senderType: 5, //机器人欢迎语热点问题推送
        },
      ];
    },
    insertNewMessage(state, payload) {
      //插入消息
      state.msgModelList.push(payload);
    },
    inserModelMessage(state, payload) {
      //发送消息
      // console.log(payload);
      const arr = state.msgModelList[state.msgModelList.length - 1];
      const { aTime, chatId, qaId } = payload;
      state.msgModelList[state.msgModelList.length - 1] = {
        ...arr,
        aTime,
        chatId,
        qaId,
      };
      state.msgModelList = JSON.parse(JSON.stringify(state.msgModelList)); //重要：转换一下才能实时渲染页面
      if (!state.msgModelList[state.msgModelList.length - 1].answer) {
        state.msgModelList[state.msgModelList.length - 1].answer =
          payload.answer;
      } else {
        state.msgModelList[state.msgModelList.length - 1].answer +=
          payload.answer;
      }
      if (!state.msgModelList[state.msgModelList.length - 1].reasoning) {
        state.msgModelList[state.msgModelList.length - 1].reasoning =
        payload.reasoning;
      }else {
          state.msgModelList[state.msgModelList.length - 1].reasoning +=
          payload.reasoning;
      }
    },
    listTabMessage(state, payload) {
      console.log(state.msgModelList);

      state.msgModelList = [state.msgModelList[0], ...payload];
    },
    tabChangeId(state, payload) {
      state.showPageId = payload;
    },
    tabChangeChatId(state, payload) {
      state.chatId = payload;
    },
    handleWsChat(state, payload) {
      //处理吐字中的状态
      state.wsChat = payload;
    },
    handleThinking(state, payload) {
      //处理thinking的状态
      state.thinking = payload;
    },
  },
  modules: {
    app,
  },
  getters
});
